import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=a0653582&"
import script from "./Note.ts?vue&type=script&lang=ts&"
export * from "./Note.ts?vue&type=script&lang=ts&"
import style0 from "@/components/ap/Lightbox.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports